// extracted by mini-css-extract-plugin
export default {"form":"Form_form__MCyoe","heading":"Form_heading__Pn+fq","input-field":"Form_input-field__eCCef","btn":"Form_btn__yHuQw"};